import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TeamV2SubteamsContainer = () => {
    return (
        <Box sx={{ p: 3 }}>
            <Paper sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom color="primary">
                    🏢 Team Subteams
                </Typography>
                <Typography variant="body1">
                    Team subteams organization page - Coming soon
                </Typography>
            </Paper>
        </Box>
    );
};

export default TeamV2SubteamsContainer;
